/**
 * 全部待审批
 * params:colums 表头数据
 * */
import { __decorate } from "tslib";
import React, { Component } from 'react';
import { Button, Select, Modal, message, Table } from 'antd';
import { connect } from '@souche-f2e/muji';
import { TableContainer } from '@/components';
import styles from '../_style/index.less';
import { dispatch } from '@@/store';
import { selectedTable } from './function';
import Allot from './Allot';
import { showRejectReason } from '@/shared/utils';
import { dealListValueShow } from '@/shared/functions';
import Authorized from '@/components/Auth/auth';
import Mapping from '@/shared/mapping';
import luban from '@souche-f2e/luban-js';
const mapStateToProps = (rootState) => ({
    approve: rootState.approve,
});
// @ts-ignore
let ApproveResultAll = class ApproveResultAll extends Component {
    constructor(props) {
        super(props);
        // desc 选中表格checkboxs
        this.onSelectedTableItem = (selectedRowKeys, selectedRows) => {
            selectedTable(selectedRowKeys, selectedRows, this.props.approve, 'All');
        };
        // desc 刷新表格
        this.tableUpdate = (page, pageSize) => {
            dispatch.approve.updateTable({ page });
        };
        // desc 审批通过
        this.agree = (data) => {
            Modal.confirm({
                title: '是否确定通过',
                onOk() {
                    dispatch.approve.agreeApprove({
                        idList: data,
                    });
                },
            });
        };
        // desc 批量通过
        this.multipleAgree = () => {
            const data = this.props.approve.checkedKeyAll;
            data.length > 0 ? this.agree(data) : message.warning('请先选择车辆');
        };
        // desc 分配
        this.allot = () => {
            dispatch.approve.getAllot({});
            const lubanID = 'PSGJB-CAR-QBSP-QBDSP-SPFP';
            luban.send({
                typeId: lubanID,
                eventType: 'click',
            });
            const slected = this.props.approve.checkedNumAll;
            if (slected > 0) {
                dispatch.approve.SHOW_ALLOT(true);
            }
            else {
                message.warning('请先选择车辆');
            }
        };
        // desc 审批驳回
        this.unAgree = (data) => {
            showRejectReason({
                id: data.goodsId,
                callback: () => {
                    dispatch.approve.updateTable({});
                },
            });
        };
        this.state = {
            tableOperate: [
                {
                    title: '申请时间',
                    dataIndex: 'createTime',
                    align: 'left',
                },
                {
                    title: '操作',
                    dataIndex: 'operation',
                    align: 'left',
                    fixed: 'right',
                    width: 180,
                    render: (text, record, index) => (<div className={'table-operate-btn'}>
              <Authorized allow={this.props.approve.isMy ? 'psgjb-carpendmine-examine' : 'psgjb-carpend-examine'}>
                <a luban-id={this.props.approve.isMy ? 'PSGJB-CAR-QBSP-WDDSP-SPTG' : 'PSGJB-CAR-QBSP-QBDSP-SPTG'} onClick={(event) => {
                        this.agree([record.goodsId]);
                    }}>
                  通过
                </a>
                <a luban-id={this.props.approve.isMy ? 'PSGJB-CAR-QBSP-WDDSP-SPBH' : 'PSGJB-CAR-QBSP-QBDSP-SPBH'} onClick={(event) => {
                        this.unAgree(record);
                    }}>
                  驳回
                </a>
              </Authorized>
            </div>),
                },
            ],
            allot: [
                {
                    title: '分配人',
                    dataIndex: 'assessor',
                },
            ],
            selectedTable: [],
            index: [
                {
                    title: '序号',
                    dataIndex: 'index',
                    fixed: 'left',
                    align: 'left',
                    width: 100,
                    render: (text, record, index) => {
                        const pageIndex = this.props.approve.pageIndexAll - 1;
                        return (<span>{(pageIndex * 20) + index + 1}</span>);
                    },
                },
            ],
        };
        this.changeTag = this.changeTag.bind(this);
    }
    componentWillMount() {
        setTimeout(() => {
            const { activeTab } = this.props.approve;
            !activeTab && dispatch.approve.updateTable({ page: 1, acyiveKey: 'All' });
        });
    }
    // desc 切换分配状态回调
    changeTag(val) {
        dispatch.approve.SET_STATE({
            activeState: val,
        });
        dispatch.approve.updateTable({});
    }
    render() {
        const { activeState, pageIndexAll, pageSizeAll, tableAll, tableAllTotal, isMy, checkedKeyAll, tableKey, loadingAll, exportParams, } = this.props.approve;
        const { tableColums } = this.props;
        const { tableOperate, allot, index } = this.state;
        const table = [...index, ...tableColums, ...(activeState === 1 ? allot : []), ...tableOperate];
        return (<React.Fragment>
        <TableContainer totalNum={tableAllTotal} isTab exportObj={{
            type: 'goods',
            params: exportParams,
            fileName: `${isMy ? '我的' : '全部'}待审批`,
            allow: isMy ? Mapping.exportAllow.psgjb_carpendmine_export.value : Mapping.exportAllow.psgjb_carpend_exporting.value,
        }}>
          <div className={styles.table_operate}>
            {!isMy && (<React.Fragment>
                  <Select value={activeState} style={{ width: 150 }} onChange={this.changeTag} getPopupContainer={(triggerNode) => {
            return triggerNode.parentNode;
        }}>
                    <Select.Option value={1}>已分配</Select.Option>
                    <Select.Option value={0}>待分配</Select.Option>
                  </Select>
                  {activeState !== 1 && (<Authorized allow={'psgjb-carpend-distribute'}>
                      <Button type="primary" onClick={this.allot}>分配</Button>
                    </Authorized>)}
                  <Authorized allow={isMy ? 'psgjb-carpendmine-allthrough' : 'psgjb-carpend-allthrough'}>
                    <Button type="primary" onClick={this.multipleAgree}>批量通过</Button>
                  </Authorized>
                </React.Fragment>)}
            {isMy && (<Authorized allow={isMy ? 'psgjb-carpendmine-allthrough' : 'psgjb-carpend-allthrough'}>
                <Button type="primary" onClick={this.multipleAgree}>批量通过</Button>
              </Authorized>)}
          </div>
          <Table scroll={{ x: '170%' }} loading={loadingAll} rowKey={tableKey} columns={table} dataSource={dealListValueShow({
            gistData: table,
            data: tableAll,
        })} rowSelection={{
            selectedRowKeys: checkedKeyAll,
            onChange: this.onSelectedTableItem,
        }} pagination={{
            current: pageIndexAll,
            pageSize: pageSizeAll,
            showQuickJumper: true,
            total: tableAllTotal,
            onChange: this.tableUpdate,
        }}/>
        </TableContainer>
        {!isMy && (<Allot />)}
      </React.Fragment>);
    }
};
ApproveResultAll = __decorate([
    connect(mapStateToProps)
], ApproveResultAll);
export default ApproveResultAll;
